import PhotoWallApp from '../photos/PhotoWallApp.jsx'
import { TEST_PHOTO_TOURNAMENT_ID } from '../lib/teststation.js'

// Render the production PhotoWallApp pinned to the fixed __testphotos__
// pseudo-tournament. Visual + behavior identical to /photowall.
//
// Why the explicit-size wrapper + `embedded`:
//
//   Production /photowall is a direct child of #root, which the global
//   stylesheet sizes to `height: 100%`. PhotoWallApp's non-embedded root
//   uses Tailwind `min-h-full` (`min-height: 100%`) and the inner image
//   stage uses `absolute inset-0`. That chain collapses the moment any
//   intermediate ancestor stops establishing a definite height — and a
//   `position: fixed; inset: 0` wrapper turned out NOT to be reliable
//   enough for the `min-height: 100%` calculation in every browser the
//   TV display targets. The image stage ended up zero-sized and the
//   `<img max-w-full max-h-full>` fell back to the photo's intrinsic
//   pixel dimensions, rendering small in the corner of a 0×0 box.
//
//   Two changes harden the chain:
//   1. The wrapper uses VIEWPORT UNITS for both axes (`100vw × 100vh`),
//      guaranteeing a definitely-sized box independent of any parent.
//   2. PhotoWallApp runs in `embedded` mode so it uses `w-full h-full`
//      (`100%` of the now-definitely-sized parent) instead of
//      `min-h-full`. The inner Slideshow then uses `h-full`, the image
//      stage `inset-0` resolves against a real box, and the photo fills
//      the viewport with `object-contain` exactly like production.
//
//   `rounded-xl` on embedded PhotoWallApp would normally show as rounded
//   corner cutouts, but the wrapper has the same `#000` background, so
//   the rounding is invisible against it.
//
// Multiple TVs/iPads can open /testphotowall simultaneously and stay in
// sync — each independently subscribes to the same RTDB path.
export default function TestPhotoWall() {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000',
        overflow: 'hidden',
      }}>
      <PhotoWallApp tournamentIdProp={TEST_PHOTO_TOURNAMENT_ID} embedded />
    </div>
  )
}
